module.exports = __webpack_public_path__ + "img/avatar-1.png?e3973b64dce414aa306e45bf74b654e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar/avatar-1.png
// module id = 149
// module chunks = 0